import { render, staticRenderFns } from "./confirmationWarehouse.vue?vue&type=template&id=8eb6735e&scoped=true"
import script from "./confirmationWarehouse.vue?vue&type=script&lang=js"
export * from "./confirmationWarehouse.vue?vue&type=script&lang=js"
import style0 from "./confirmationWarehouse.vue?vue&type=style&index=0&id=8eb6735e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb6735e",
  null
  
)

export default component.exports